import { http } from "~/utils";

export default {
    fileUpload: async (url, file, form = {}) => {
        const formData = new FormData();
        formData.append("uploaded_file", file);
        Object.keys(form).forEach(key => formData.append(key, form[key]));

        try {
            const response = await http.post(url, formData, {
                headers: { "content-type": "multipart/form-data" }
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    neoImporterInformation: async url => {
        try {
            const response = await http.get(url);
            const data = response ? response.data : null;

            if (data) {
                Object.keys(data).forEach(key => {
                    if (typeof data[key] === "string") {
                        data[key] = data[key].replace(process.env.REACT_APP_API_VERSION, "");
                    }
                });
            }
            return data;
        } catch (error) {
            console.error("Error fetching importer information", error);
            return null;
        }
    },

    validateFileUploaded: async url => {
        const response = await http.get(url);
        return {
            ...(response.data.celery_tasks ? { celery_tasks: response.data.celery_tasks } : {}),
            results: response.data.results
        };
    },

    getResultsSummary: async url => {
        const response = await http.get(url);
        return response.data.results;
    },

    processFile: async url => {
        const response = await http.post(url);
        return response.data.results;
    },

    getStatusImport: async url => {
        const response = await http.get(url);
        return response.data;
    },

    getNeoImporters: async (page = 1, filters = {}) => {
        const response = await http.get("india/file-upload-history/", {
            params: { ...filters, page }
        });

        return {
            list: response.data.results,
            pagination: {
                actual: response.data.actual,
                count: response.data.count,
                next: response.data.next,
                pages: response.data.pages,
                previous: response.data.previous
            }
        };
    },

    getInfoField: async () => {
        const response = await http.get("india/file-upload-history/info-field", { params: {} });
        return response.data;
    },

    resultsFileUploaded: async url => {
        const response = await http.get(url);
        const data = response.data;

        const backward_url = data.backward_url || null;
        const backward_data = data.backward_data || null;

        return {
            ...(data.celery_tasks && { celery_tasks: data.celery_tasks }),
            enable_backward: !!(data.enable_backward || backward_url || backward_data),
            ...(backward_data && { backward_data }),
            ...(backward_url && { backward_url }),
            results: data.results
        };
    },
};
